if (!customElements.get('tccs-mobile-buybar')) {
  customElements.define(
    'tccs-mobile-buybar',
    class TccsMobileBuybar extends HTMLElement {
      connectedCallback() {
        this.primaryButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        this.priceSource = document.getElementById(`price-${this.dataset.section}`);
        this.mobileButton = this.querySelector('[data-tccs-mobile-submit]');
        this.mobilePrice = this.querySelector('[data-tccs-mobile-price]');

        if (!this.primaryButton || !this.mobileButton) return;

        this.onScroll = this.onScroll.bind(this);
        this.onSubmit = () => this.primaryButton.click();
        this.mobileButton.addEventListener('click', this.onSubmit);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(this.primaryButton, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true,
        });

        if (this.priceSource) {
          this.priceObserver = new MutationObserver(() => this.syncPrice());
          this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
        }

        this.syncButton();
        this.syncPrice();
        this.onScroll();
      }

      disconnectedCallback() {
        this.mobileButton?.removeEventListener('click', this.onSubmit);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.buttonObserver?.disconnect();
        this.priceObserver?.disconnect();
      }

      syncButton() {
        this.mobileButton.disabled = this.primaryButton.disabled;
        const label = this.primaryButton.querySelector('span')?.textContent?.trim();
        if (label) this.mobileButton.textContent = label;
      }

      syncPrice() {
        const price = this.priceSource?.querySelector('.price-item--sale, .price-item--regular')?.textContent?.trim();
        if (price) this.mobilePrice.textContent = price;
      }

      onScroll() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          const passedPrimaryButton = this.primaryButton.getBoundingClientRect().bottom < 0;
          this.classList.toggle('is-active', window.innerWidth <= 749 && passedPrimaryButton);
          this.frame = null;
        });
      }
    }
  );
}
